const groupKeys = {
  CUSTOMER: 'Kunden',
  SUPPLIER: 'Lieferanten',
  CONTACT: 'Ansprechpartner',
  ADDRESS: 'Adressen',
  PRODUCT: 'Artikel',
  CATEGORY: 'Kategorien',
  DOCUMENT: 'Verkaufsvorgänge',
  LEGACY_DOCUMENT: 'Altbelege',
  PURCHASE_ORDER: 'Bestellungen',
  GOODS_RECEIPT: 'Wareneingänge',
  BATCH: 'Chargen',
  DMS_DOCUMENT: 'Dokumente',
  ACTIVITY: 'Aktivitäten',
  CALL: 'Telefonate',
} as const;

export const searchDe = {
  open: 'Globale Suche öffnen',
  title: 'Globale Suche',
  description: 'Durchsucht alle Bereiche, für die Sie Leserechte besitzen.',
  placeholder: 'Kunden, Artikel, Belege …',
  shortcut: '⌘/Ctrl K',
  loading: 'Suchergebnisse werden geladen',
  error: 'Die Suche ist momentan nicht verfügbar.',
  empty: 'Keine passenden Treffer. Prüfen Sie Schreibweise oder Nummer.',
  noRecent: 'Noch keine zuletzt geöffneten Datensätze.',
  resultCount_one: '{{count}} Treffer',
  resultCount_other: '{{count}} Treffer',
  groups: groupKeys,
} as const;

export const searchEn = {
  open: 'Open global search',
  title: 'Global search',
  description: 'Searches every area for which you have read access.',
  placeholder: 'Customers, products, documents …',
  shortcut: '⌘/Ctrl K',
  loading: 'Loading search results',
  error: 'Search is currently unavailable.',
  empty: 'No matching results. Check the spelling or number.',
  noRecent: 'No recently opened records yet.',
  resultCount_one: '{{count}} result',
  resultCount_other: '{{count}} results',
  groups: {
    CUSTOMER: 'Customers',
    SUPPLIER: 'Suppliers',
    CONTACT: 'Contacts',
    ADDRESS: 'Addresses',
    PRODUCT: 'Products',
    CATEGORY: 'Categories',
    DOCUMENT: 'Sales transactions',
    LEGACY_DOCUMENT: 'Historical documents',
    PURCHASE_ORDER: 'Purchase orders',
    GOODS_RECEIPT: 'Goods receipts',
    BATCH: 'Batches',
    DMS_DOCUMENT: 'Documents',
    ACTIVITY: 'Activities',
    CALL: 'Calls',
  },
} as const;

export const searchTr = {
  open: 'Genel aramayı aç',
  title: 'Genel arama',
  description: 'Okuma yetkinizin bulunduğu tüm alanlarda arama yapar.',
  placeholder: 'Müşteriler, ürünler, belgeler …',
  shortcut: '⌘/Ctrl K',
  loading: 'Arama sonuçları yükleniyor',
  error: 'Arama şu anda kullanılamıyor.',
  empty: 'Eşleşen sonuç yok. Yazımı veya numarayı kontrol edin.',
  noRecent: 'Henüz yakın zamanda açılan kayıt yok.',
  resultCount_one: '{{count}} sonuç',
  resultCount_other: '{{count}} sonuç',
  groups: {
    CUSTOMER: 'Müşteriler',
    SUPPLIER: 'Tedarikçiler',
    CONTACT: 'İlgili kişiler',
    ADDRESS: 'Adresler',
    PRODUCT: 'Ürünler',
    CATEGORY: 'Kategoriler',
    DOCUMENT: 'Satış işlemleri',
    LEGACY_DOCUMENT: 'Geçmiş belgeler',
    PURCHASE_ORDER: 'Satın alma siparişleri',
    GOODS_RECEIPT: 'Mal kabulleri',
    BATCH: 'Partiler',
    DMS_DOCUMENT: 'Belgeler',
    ACTIVITY: 'Faaliyetler',
    CALL: 'Aramalar',
  },
} as const;

export const searchFr = {
  open: 'Ouvrir la recherche globale',
  title: 'Recherche globale',
  description: 'Recherche dans toutes les zones pour lesquelles vous avez un droit de lecture.',
  placeholder: 'Clients, articles, documents …',
  shortcut: '⌘/Ctrl K',
  loading: 'Chargement des résultats',
  error: 'La recherche est momentanément indisponible.',
  empty: 'Aucun résultat. Vérifiez l’orthographe ou le numéro.',
  noRecent: 'Aucun enregistrement ouvert récemment.',
  resultCount_one: '{{count}} résultat',
  resultCount_other: '{{count}} résultats',
  groups: {
    CUSTOMER: 'Clients',
    SUPPLIER: 'Fournisseurs',
    CONTACT: 'Contacts',
    ADDRESS: 'Adresses',
    PRODUCT: 'Articles',
    CATEGORY: 'Catégories',
    DOCUMENT: 'Opérations de vente',
    LEGACY_DOCUMENT: 'Documents historiques',
    PURCHASE_ORDER: 'Commandes fournisseurs',
    GOODS_RECEIPT: 'Réceptions',
    BATCH: 'Lots',
    DMS_DOCUMENT: 'Documents',
    ACTIVITY: 'Activités',
    CALL: 'Appels',
  },
} as const;

export const searchEs = {
  open: 'Abrir búsqueda global',
  title: 'Búsqueda global',
  description: 'Busca en todas las áreas para las que tiene permiso de lectura.',
  placeholder: 'Clientes, artículos, documentos …',
  shortcut: '⌘/Ctrl K',
  loading: 'Cargando resultados',
  error: 'La búsqueda no está disponible en este momento.',
  empty: 'No hay resultados. Compruebe la ortografía o el número.',
  noRecent: 'Aún no hay registros abiertos recientemente.',
  resultCount_one: '{{count}} resultado',
  resultCount_other: '{{count}} resultados',
  groups: {
    CUSTOMER: 'Clientes',
    SUPPLIER: 'Proveedores',
    CONTACT: 'Contactos',
    ADDRESS: 'Direcciones',
    PRODUCT: 'Artículos',
    CATEGORY: 'Categorías',
    DOCUMENT: 'Operaciones de venta',
    LEGACY_DOCUMENT: 'Documentos históricos',
    PURCHASE_ORDER: 'Pedidos de compra',
    GOODS_RECEIPT: 'Entradas de mercancía',
    BATCH: 'Lotes',
    DMS_DOCUMENT: 'Documentos',
    ACTIVITY: 'Actividades',
    CALL: 'Llamadas',
  },
} as const;

export const searchRu = {
  open: 'Открыть глобальный поиск',
  title: 'Глобальный поиск',
  description: 'Поиск во всех разделах, доступных вам для чтения.',
  placeholder: 'Клиенты, товары, документы …',
  shortcut: '⌘/Ctrl K',
  loading: 'Загрузка результатов',
  error: 'Поиск временно недоступен.',
  empty: 'Совпадений нет. Проверьте написание или номер.',
  noRecent: 'Недавно открытых записей пока нет.',
  resultCount_one: '{{count}} результат',
  resultCount_other: '{{count}} результата',
  groups: {
    CUSTOMER: 'Клиенты',
    SUPPLIER: 'Поставщики',
    CONTACT: 'Контакты',
    ADDRESS: 'Адреса',
    PRODUCT: 'Товары',
    CATEGORY: 'Категории',
    DOCUMENT: 'Продажи',
    PURCHASE_ORDER: 'Заказы поставщикам',
    GOODS_RECEIPT: 'Приёмка товара',
    BATCH: 'Партии',
    DMS_DOCUMENT: 'Документы',
    ACTIVITY: 'Действия',
    CALL: 'Звонки',
  },
} as const;
